import initialState from './initialState';
import produce from 'immer';

export default (state = initialState.dice, action) => {
	switch (action.type) {
		case 'RESET_WHOLE_STATE':
			return initialState.dice;
		//
		case 'SET_DICE':
			return produce(state, (draft) => {
				draft.chosenDice = action.value;
			});

		case 'SHOW_DICE':
			return produce(state, (draft) => {
				draft.showDialog = action.value;
			});

		case 'SET_HIGHEST_BET':
			return produce(state, (draft) => {
				if (action.value > draft.highestBet) {
					draft.highestBet = action.value;
				}
			});

		case 'RESET_HIGHEST_BET':
			return produce(state, (draft) => {
				draft.highestBet = 0;
			});

		default:
			return state;
	}
};
